import "assets/scss/layouts/auth.scss";
import React, { useEffect, useState } from "react";
import { useApp } from "context";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Constants, Helpers, Routes } from "utils";
import { Content, Custom } from "components";
import { Typography } from "@mui/material";

type Props = {};

export const AuthLayout = (props: Props) => {
  const { feedback, setFeedback, t, theme } = useApp();
  // TODO: should be improved
  const location = useLocation();

  const [tacModal, setTacModal] = useState(false);
  const [privacyPolicyModal, setPrivacyPolicyModal] = useState(false);

  // TODO: find a way to clear the feedback message after displaying it
  const hasMessage = feedback && Helpers.hasValue(feedback.message);

  // TODO: this is so stupid!!
  const isSign =
    [
      Routes.auth.signin,
      Routes.auth.signup,
      Routes.auth.forgotPassword,
    ].includes(location.pathname) || location.pathname.includes("hub");

  useEffect(() => {
    if (hasMessage) {
      const timeout = setTimeout(
        () => setFeedback(null),
        Constants.REFRESH_RATE.ALERT
      );
      return () => clearTimeout(timeout);
    }
  }, [hasMessage]);

  return (
    <>
      <div
        className="qh-auth"
        style={{
          color: theme.palette.font.color,
          backgroundColor: theme.palette.background.color,
        }}
      >
        <div className="qh-container">
          <div className="qh-header">
            {hasMessage && (
              <Custom.Alert
                variant="filled"
                severity={feedback?.severity ?? undefined}
              >
                {feedback?.message}
              </Custom.Alert>
            )}
          </div>
          <div
            className="qh-content"
            style={{
              color: theme.palette.font.accent,
              backgroundColor: theme.palette.background.accent,
            }}
          >
            <Outlet />
            {isSign && (
              <div className="qh-footer">
                <div className="footnote">
                  <Typography
                    className="link-text"
                    onClick={() => setTacModal(true)}
                    style={{ color: theme.palette.font.color }}
                  >
                    {t.label.tac}
                  </Typography>
                  <Typography
                    className="link-text"
                    onClick={() => setPrivacyPolicyModal(true)}
                    style={{ color: theme.palette.font.color }}
                  >
                    {t.label.privacy_policy}
                  </Typography>
                </div>
                <Custom.Modal
                  header={t.label.privacy_policy}
                  opened={privacyPolicyModal}
                  onClose={() => setPrivacyPolicyModal(false)}
                >
                  <Content.PrivacyPolicy />
                </Custom.Modal>
                <Custom.Modal
                  header={t.label.tac}
                  opened={tacModal}
                  onClose={() => setTacModal(false)}
                >
                  <Content.TermsAndConditions />
                </Custom.Modal>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
